export default "__VITE_ASSET__CPoXwDgz__"